<a (click)="navigate()">
    <app-icon name="arrow_left" />
    {{label}}
</a>
